import { motion } from 'framer-motion';
import Navigation from '../home/components/Navigation';
import Footer from '../home/components/Footer';

export default function TermsPage() {
  const sections = [
    {
      title: '第1条（適用）',
      content: '本規約は、本サービスの利用に関する条件を、本サービスを利用するすべてのユーザーと当社との間で定めるものです。本サービスを利用する場合、本規約に同意したものとみなします。'
    },
    {
      title: '第2条（サービス内容）',
      content: '本サービスは、車両のホイールシミュレーション機能を提供するウェブサイトです。ユーザーは、本サービスを通じて様々な車両とホイールの組み合わせを視覚的に確認することができます。'
    },
    {
      title: '第3条（利用資格）',
      content: '本サービスは、どなたでも無料でご利用いただけます。ただし、未成年者が本サービスを利用する場合、保護者の同意が必要です。'
    },
    {
      title: '第4条（禁止事項）',
      content: 'ユーザーは、本サービスの利用にあたり、以下の行為をしてはなりません。\n\n・法令または公序良俗に違反する行為\n・犯罪行為に関連する行為\n・当社のサーバーまたはネットワークの機能を破壊したり、妨害したりする行為\n・当社のサービスの運営を妨害するおそれのある行為\n・他のユーザーに関する個人情報等を収集または蓄積する行為\n・他のユーザーに成りすます行為\n・当社のサービスに関連して、反社会的勢力に対して直接または間接に利益を供与する行為\n・その他、当社が不適切と判断する行為'
    },
    {
      title: '第5条（免責事項）',
      content: '当社は、本サービスに関して、ユーザーと他のユーザーまたは第三者との間において生じた取引、連絡または紛争等について一切責任を負いません。本サービスに表示される情報は参考情報であり、実際の製品とは異なる場合があります。'
    },
    {
      title: '第6条（著作権）',
      content: '本サービスに掲載されているコンテンツの著作権または知的財産権は、当社または当社にライセンスを許諾している第三者に帰属しています。ユーザーは、当社の事前の承諾なく、これらのコンテンツを複製、転載、配布することはできません。'
    },
    {
      title: '第7条（サービスの変更・終了）',
      content: '当社は、ユーザーへの事前の通知なく、本サービスの内容を変更し、または提供を終了することができます。これによってユーザーに生じた損害について、当社は一切の責任を負いません。'
    },
    {
      title: '第8条（利用規約の変更）',
      content: '当社は、必要と判断した場合には、ユーザーに通知することなくいつでも本規約を変更することができます。変更後の本規約は、本サービス上に表示した時点より効力を生じるものとします。'
    },
    {
      title: '第9条（準拠法・裁判管轄）',
      content: '本規約の解釈にあたっては、日本法を準拠法とします。本サービスに関して紛争が生じた場合には、当社の本店所在地を管轄する裁判所を専属的合意管轄とします。'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#0a0a0a] via-[#0f0f0f] to-[#0a0a0a]">
      <Navigation />
      
      <div className="pt-24 pb-16 px-5">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-12"
          >
            <h1 className="text-white text-4xl font-thin tracking-[0.3em] uppercase mb-4">
              利用規約
            </h1>
            <p className="text-[#888888] text-sm">
              Terms of Service
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="bg-[#1a1a1a] rounded-2xl p-8 mb-8"
          >
            <p className="text-[#cccccc] text-sm leading-relaxed">
              この利用規約（以下、「本規約」といいます。）は、ブリッジアドバンス合同会社（以下、「当社」といいます。）がこのウェブサイト上で提供するサービス（以下、「本サービス」といいます。）の利用条件を定めるものです。
            </p>
          </motion.div>

          <div className="space-y-6">
            {sections.map((section, index) => (
              <motion.div
                key={section.title}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3 + index * 0.1 }}
                className="bg-[#1a1a1a] rounded-2xl p-8 border border-[#2a2a2a] hover:border-[#00d4ff]/30 transition-colors"
              >
                <h2 className="text-white text-xl font-medium mb-4 tracking-wide">
                  {section.title}
                </h2>
                <p className="text-[#cccccc] text-sm leading-relaxed whitespace-pre-line">
                  {section.content}
                </p>
              </motion.div>
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.5 }}
            className="mt-12 text-center"
          >
            <p className="text-[#888888] text-sm mb-6">
              制定日：2025年1月1日
            </p>
            <div className="bg-[#1a1a1a] rounded-2xl p-6 inline-block">
              <p className="text-[#cccccc] text-sm mb-2">運営会社</p>
              <a 
                href="https://bridgeadvance.llc/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-white text-lg hover:text-[#00d4ff] transition-colors cursor-pointer font-medium"
              >
                ブリッジアドバンス合同会社
              </a>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.7 }}
            className="mt-12 text-center"
          >
            <a 
              href="/"
              className="inline-block px-8 py-3 bg-[#00d4ff] text-black text-sm font-medium rounded-full hover:bg-[#00b8e6] transition-colors cursor-pointer whitespace-nowrap"
            >
              ホームに戻る
            </a>
          </motion.div>
        </div>
      </div>

      <Footer />
    </div>
  );
}